import { render, staticRenderFns } from "./normal_students.vue?vue&type=template&id=d89da618&scoped=true"
import script from "./normal_students.vue?vue&type=script&lang=js"
export * from "./normal_students.vue?vue&type=script&lang=js"
import style0 from "./normal_students.vue?vue&type=style&index=0&id=d89da618&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d89da618",
  null
  
)

export default component.exports